import '@angular/compiler';
import 'reflect-metadata';
import 'src/polyfills';
import 'zone.js';